import React, { useEffect } from 'react';
import { VerifyInvite as SharedVerifyInvite } from '../auth/login/components/VerifyInvite';
import { useProfileContext } from '../../contexts/ProfileProvider';
import { useNavigate, useParams } from 'react-router-dom';

export const VerifyInvite = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { profile } = useProfileContext();

  useEffect(() => {
    if (profile) {
      navigate('/home');
    }
  }, [navigate, profile]);

  return <SharedVerifyInvite token={token} />;
};
